import { NextCargoLoader } from "./NextCargoLoader";
import { RingLoader } from "./RingLoader";

export const CustomLoader = {
  Ring: RingLoader,
  NextCargo: NextCargoLoader
};
